import React from "react";
import NotificationSystem from "react-notification-system";
import {
  Card,
  CardImg,
  CardBody,
  Col,
  Row,
  Button,
  Input,
  Label,
  CardFooter,
  FormGroup,
  Form,
} from "reactstrap";
import * as Server from "../Server";
import * as GeneralFunctions from "../GeneralFunctions";
import Page from "../components/Page";
import PageSpinner from "../components/PageSpinner";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";

class PrayerTimeBannersEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      file: {},
      arcFile: {},
      fileName: "",
      arcFileName: "",
      prayerTimeBanner: props.prayerTimeBanner || {},
    };
    this.updatePrayerTimeBanners = this.updatePrayerTimeBanners.bind(this);
  }

  componentDidMount() {}

  updatePrayerTimeBanners = async (event) => {
    event.preventDefault();
    try {
      if (!this.state.fileName && !this.state.arcFileName) {
        this.notificationSystem.addNotification({
          message: "Select the file",
          level: "error",
        });
        return;
      }
      this.setState({ showLoader: true });
      let formData = new FormData();
      formData.append("name", this.state.prayerTimeBanner.name);
      if (this.state.fileName) {
        formData.append("prayerPageBanner", this.state.file);
      }
      if (this.state.arcFileName) {
        formData.append("prayerArcBanner", this.state.arcFile);
      }
      let response = await Server.serverRequest({
        url: "/prayerPage/updatePrayerTimeBanners",
        method: "POST",
        data: formData,
      });
      if (response) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.closeEditPage(true);
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  handleChangeForBanner = (event) => {
    const fileUploaded = event.target.files[0];
    this.setState({
      file: fileUploaded,
      fileName: fileUploaded.name,
    });
  };

  handleChangeForArc = (event) => {
    const fileUploadedForArc = event.target.files[0];
    this.setState({
      arcFile: fileUploadedForArc,
      arcFileName: fileUploadedForArc.name,
    });
  };

  closeEditPage = (value) => {
    this.props.closePrayerTimeBannersEditPage({ refreshList: value });
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page
          title={
            this.props.editPrayerTimeBannerKey
              ? "Edit Prayer Time Banners"
              : "Add Prayer Time Banners"
          }
          breadcrumbs={[
            {
              name: this.props.editPrayerTimeBannerKey
                ? "Edit Prayer Time Banners"
                : "Add Prayer Time Banners",
              active: true,
            },
          ]}
        >
          <Row>
            <Col>
              <Card className="mb-3">
                <CardBody>
                  <Form
                    onSubmit={
                      this.props.editPrayerTimeBannerKey
                        ? this.updatePrayerTimeBanners
                        : this.createPrayerTimeBanners
                    }
                  >
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="name">Name</Label>
                          <Input
                            disabled
                            value={GeneralFunctions.capitalizeFirstLetter(
                              this.state.prayerTimeBanner.name
                            )}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label>Banner</Label>
                          <br />
                          {this.state.prayerTimeBanner.banners ? (
                            <CardImg
                              src={this.state.prayerTimeBanner.banners[0]}
                              alt=""
                            ></CardImg>
                          ) : (
                            "No Image"
                          )}
                          <br />
                          <Label htmlFor="file" style={{ marginTop: "30px" }}>
                            <span className="btn btn-secondary">
                              Select File
                            </span>
                            <span style={{ marginLeft: "5px" }}>
                              {this.state.fileName}
                            </span>
                          </Label>
                          <input
                            style={{ display: "none" }}
                            id="file"
                            type="file"
                            accept=".png,.jpg,.jpeg"
                            onChange={this.handleChangeForBanner}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label>Moon/Sun Arc</Label>
                          <br />
                          {this.state.prayerTimeBanner.banners ? (
                            <CardImg
                              style={{
                                backgroundColor: "rgba(0, 0, 0, 0.30)",
                              }}
                              src={this.state.prayerTimeBanner.banners[1]}
                              alt=""
                            ></CardImg>
                          ) : (
                            "No Image"
                          )}
                          <br />
                          <Label
                            htmlFor="arcFile"
                            style={{ marginTop: "30px" }}
                          >
                            <span className="btn btn-secondary">
                              Select File
                            </span>
                            <span style={{ marginLeft: "5px" }}>
                              {this.state.arcFileName}
                            </span>
                          </Label>
                          <input
                            style={{ display: "none" }}
                            id="arcFile"
                            type="file"
                            accept=".png,.jpg,.jpeg"
                            onChange={this.handleChangeForArc}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        {this.props.editPrayerTimeBannerKey ? (
                          <Button color="primary" type="submit">
                            Update
                          </Button>
                        ) : (
                          <Button color="primary" type="submit">
                            Create
                          </Button>
                        )}
                      </Col>
                      <Col>
                        <Button
                          color="secondary"
                          onClick={(event) => {
                            this.closeEditPage(false);
                          }}
                        >
                          Cancel
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
                <CardFooter></CardFooter>
              </Card>
            </Col>
          </Row>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
export default PrayerTimeBannersEdit;
